import script from "./AppBuildOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBuildOptions.vue?vue&type=script&setup=true&lang=ts"

import "./AppBuildOptions.vue?vue&type=style&index=0&id=772165be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772165be"]])

export default __exports__